import { createSelector } from 'reselect';
import { sportRewardsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const sportRewardsYearsSelector = createSelector([sportRewardsSelector], (sportRewards) =>
  extractDatesFromNestedItems(
    [sportRewards.content],
    [
      {
        type: 'date',

        field: 'date',
      },
    ],
  ),
);
